<script>
import BlockCompany from 'vcomponents/common/object/BlockCompany.vue';
export default {
    components: { BlockCompany },
    extends: BlockCompany,
    data() {
        return {
            objectType: 'individual',
        };
    },
};
</script>
